module.exports = __webpack_public_path__ + "img/logo-yabawt.0542f140.svg";